// Module
var code = `<div class="{{centered?'js-dateTimeCentered':'js-dateTimeLabel'}}">

    {{#if expired}}
        <div class="js-dateTimeLabelTextExpired">{{lifeTimeExpiredLabel}}</div>
    {{else}}

        {{#if days > 0}}
            <div class="js-dateTimeDaysIMG">
                <svg>
                    <circle cx="4" cy="4" r="3" />
                </svg>
            </div>
            <div class="js-dateTimeLabelText">{{days}} {{daysLabel}}</div>
        {{/if}}

        {{#if hours > 0}}
            <div class="js-dateTimeHoursIMG">
                <svg>
                    <circle cx="4" cy="4" r="3" />
                </svg>
            </div>
            <div class="js-dateTimeLabelText">{{hours}} {{hoursLabel}}</div>
        {{/if}}

        {{#if minutes > 0}}
            <div class="js-dateTimeMinutesIMG">
                <svg>
                    <circle cx="4" cy="4" r="3" />
                </svg>
            </div>
            <div class="js-dateTimeLabelText">{{minutes}} {{minutesLabel}}</div>
        {{/if}}

        {{#if seconds >= 0}}
            <div class="js-dateTimeSecondsIMG">
                <svg>
                    <circle cx="4" cy="4" r="3" />
                </svg>
            </div>
            <div class="js-dateTimeLabelText">{{seconds}} {{secondsLabel}}</div>
        {{/if}}

    {{/if}}
</div>`;
// Exports
export default code;